// AiAgentBotSettings/index.js - COMPLETE FIXED VERSION
import React, { useEffect, useState, useCallback, useRef } from "react";
import AlertPopup from "../../../AlertPopup";
import LoaderComp from "../../../LoaderComp";
import styles from "../LeadGenBotSettings/BotSettings.module.css";
import AIAgentBot from "../../../app_components/AIAgentBot";
import Modal from "../../../Modal";
import modalContentSty from "../LeadGenBotSettings/ModalContent.module.css";
import newsSocketService from "../../../../services/newsSocketService";

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

console.log("it seems it is working! if you see this??");

const CORE_KEYS = [
  "ai_agent_bot_enabled",
  "live_agent_enabled",
  "allow_nested",
  "dont_show_chat_box_at_logout",
  "exclude_paths",
  "app_id",
  "auth_key",
  "chat_settings",
  "enabled_bot_content",
  "feature",
  "region",
  "role",
  "settings",
  "tenant_id",
  "timestamp",
  "tenant_info",
  "isTraining",
];

const getToken = () => localStorage.getItem("token");

export default function AiAgentBotSettings({
  appData,
  tenantPlan,
  onTrainingComplete,
  onAppDataPatch,
}) {
  console.log("version5555 - FIXEDdddddddd");

  const [initialData, setInitialData] = useState(null);
  const [botContent, setBotContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const [localChatSettings, setLocalChatSettings] = useState(
    appData.chat_settings,
  );
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingUpdatePayloads, setPendingUpdatePayloads] = useState({
    payload1: null,
  });

  // Use refs to persist values across renders
  const pendingTrainingDataRef = useRef(null);
  const shouldTriggerTrainingRef = useRef(false);
  const isTrainingPreparedRef = useRef(false);

  // State to force re-render when needed
  const [updateButtonKey, setUpdateButtonKey] = useState(0);

  const isPreviousIngested = (data) =>
    ["files", "urls", "sitemap"].some((key) => {
      const section = data[key];
      if (!section) return false;

      return (
        (section.ingested && section.ingested.length > 0) ||
        section.count > 0 ||
        section.failed_count > 0
      );
    });

  const handleTrainingRequest = (trainingConfig) => {
    console.log(
      "📋 Received training config in AiAgentBotSettings:",
      trainingConfig,
    );
    pendingTrainingDataRef.current = trainingConfig;
    shouldTriggerTrainingRef.current = true;
    isTrainingPreparedRef.current = true;

    // Force re-render to update button state
    setUpdateButtonKey((prev) => prev + 1);

    showAlert(
      "info",
      "Training data prepared. Click 'Update AI Agent' to start training.",
    );
  };

  // Listen for training completion events via WebSocket
  useEffect(() => {
    if (!botContent?.app_name) return;

    console.log(
      "🔌 Setting up WebSocket listener for training completion on app:",
      botContent,
    );
    newsSocketService.connect();

    const handleTrainingCompletion = (data) => {
      console.log(
        "🎓 Training completion received in AiAgentBotSettings:",
        data,
        botContent,
      );

      if (
        data.app_name === botContent.app_name &&
        (data.tenant_id === botContent.tenant_id ||
          data.tenant_id === botContent.tenant_info?.id)
      ) {
        console.log(
          `${botContent} ✅ Training completion matches current app: ${botContent.app_name}`,
        );

        setBotContent((prev) => ({
          ...prev,
          isTraining: 2,
        }));

        // Reset training flags
        shouldTriggerTrainingRef.current = false;
        isTrainingPreparedRef.current = false;
        pendingTrainingDataRef.current = null;
        setUpdateButtonKey((prev) => prev + 1);

        showAlert(
          "success",
          `AI Agent training completed successfully for "${botContent.app_name}"!`,
        );

        // 🔄 Call the parent's refresh callback to reload appData
        if (onTrainingComplete) {
          console.log("🔄 Calling onTrainingComplete to refresh app data");
          onTrainingComplete();
        }
      } else {
        console.log(
          `⏭️ Training completion for different app: ${data.app_name} (current: ${botContent.app_name})`,
        );
      }
    };

    const unsubscribe = newsSocketService.subscribe(
      "training_completion",
      handleTrainingCompletion,
    );

    return () => {
      console.log("🧹 Cleaning up training completion listener");
      unsubscribe();
    };
  }, [
    botContent?.app_name,
    botContent?.tenant_id,
    botContent?.tenant_info?.id,
    onTrainingComplete,
  ]);

  const executeTraining = async () => {
    const trainingDataToUse = pendingTrainingDataRef.current;

    if (!trainingDataToUse) {
      console.log("No pending training data, returning");
      return;
    }

    setBotContent((prev) => ({
      ...prev,
      isTraining: 1,
    }));

    // Clear the refs
    pendingTrainingDataRef.current = null;
    shouldTriggerTrainingRef.current = false;
    isTrainingPreparedRef.current = false;
    setUpdateButtonKey((prev) => prev + 1);

    showAlert("success", "AI Agent updated! Training started in background.");

    (async () => {
      try {
        const formData = new FormData();
        formData.append("kb_id", trainingDataToUse.kb_id);
        formData.append("tenant", trainingDataToUse.tenant);
        formData.append("app_name", trainingDataToUse.app_name);
        formData.append("region", appData.region.toLowerCase());
        formData.append("tenant_uid", appData.tenant_info.id);

        if (
          trainingDataToUse.urlsEnabled &&
          trainingDataToUse.localUrls.length > 0
        ) {
          const urlsData = {
            urls: trainingDataToUse.localUrls.map((url) => ({
              url: url.url,
              force_reingest: url.force_reingest || false,
              force_delete: url.force_delete || false,
              explore_clickables:
                url.explore_clickables ||
                trainingDataToUse.globalExploreClickables ||
                false,
            })),
            title: "Multiple URLs",
            allow_nested: trainingDataToUse.allowNested,
            explore_clickables:
              trainingDataToUse.globalExploreClickables || false,
          };
          formData.append("urls", JSON.stringify(urlsData));
        }

        if (
          trainingDataToUse.sitemapEnabled &&
          trainingDataToUse.localSitemap
        ) {
          const sitemapData = {
            sitemap_url: trainingDataToUse.localSitemap,
            title: "Sitemap",
          };
          formData.append("sitemap", JSON.stringify(sitemapData));
        }

        if (
          trainingDataToUse.filesEnabled &&
          trainingDataToUse.localFiles.length > 0
        ) {
          const filesConfig = {
            files: trainingDataToUse.localFiles.map((file) => ({
              fileName: file.fileName,
              force_reingest:
                file.force_reingest !== undefined ? file.force_reingest : false,
              force_delete:
                file.force_delete !== undefined ? file.force_delete : false,
            })),
            title: "Multiple Files",
          };
          formData.append("files", JSON.stringify(filesConfig));

          trainingDataToUse.localFiles.forEach((file) => {
            if (file.fileObject) {
              let fileToUpload = file.fileObject;
              if (!file.isNew && file.force_reingest) {
                fileToUpload = new File([file.fileObject], file.fileName, {
                  type: file.fileObject.type,
                  lastModified: file.fileObject.lastModified,
                });
              }
              formData.append("uploaded_files", fileToUpload);
            }
          });
        }
        const token = getToken();

        const url = `https://${trainingDataToUse.region.toLowerCase()}.autobot2.${backend_api_base_url}/ai_ingest_sys?task=ingest`;
        const response = await fetch(url, {
          method: "POST",
          body: formData,
          headers: {
            "x-api-key":
              "ZmFzaG9uaV9zdXBwb3J0X19TRVBSQVRPUl9fZmFzaG9uaV9hcHAx",
            Authorization: token,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Training API called successfully:", data);
      } catch (error) {
        console.error("Error during background training:", error);
        setBotContent((prev) => ({
          ...prev,
          isTraining: 3,
        }));
      }
    })();
  };

  const confirmUpdate = async (confirmed) => {
    setShowConfirmModal(false);

    if (!confirmed) {
      showAlert("info", "Update cancelled.");
      return;
    }

    const { payload1 } = pendingUpdatePayloads;

    if (!payload1) {
      showAlert("error", "Update data not found");
      return;
    }

    setUpdating(true);

    try {
      if (shouldTriggerTrainingRef.current && pendingTrainingDataRef.current) {
        payload1.isTraining = 1;
      }

      const region_prefix = appData.region.toLowerCase();
      const token = getToken();

      console.log("here is tokensdftoken", token);
      const updateAppResponse = await fetch(
        `https://${region_prefix}.apps2.${backend_api_base_url}/update_app?act_type=tenant&app_name=${appData.app_name}`,
        {
          method: "PUT",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload1),
        },
      );

      const updateAppData = await updateAppResponse.json();

      if (!updateAppResponse.ok) {
        showAlert("error", "Failed to update AI Agent configuration");
        setUpdating(false);
        return;
      }

      setInitialData({
        botContent: { ...botContent },
        chatSettings: { ...localChatSettings },
      });

      // ─────────────────────────────────────────────
      // Lift the persisted bot flag up to AppDetailPage
      // so Credentials sees fresh state immediately.
      // ─────────────────────────────────────────────
      if (onAppDataPatch) {
        onAppDataPatch({
          ai_agent_bot_enabled: botContent.ai_agent_bot_enabled,
        });
      }

      if (shouldTriggerTrainingRef.current && pendingTrainingDataRef.current) {
        console.log(
          "Update successful, now triggering training in background...",
        );
        executeTraining();
      } else {
        showAlert("success", "AI Agent settings updated successfully!");
      }

      if (window.MyPackage?.processHardReset) {
        window.MyPackage.processHardReset(
          token,
          appData.app_name,
          appData.region.toLowerCase(),
        );
      }
    } catch (error) {
      console.error("Update failed:", error);
      showAlert("error", "Update failed: " + error.message);
    } finally {
      setUpdating(false);
      setPendingUpdatePayloads({ payload1: null });
    }
  };

  const hasChanges = () => {
    if (!initialData || !botContent) return false;

    const botContentWithoutTraining = { ...botContent };
    const initialBotContentWithoutTraining = { ...initialData.botContent };

    delete botContentWithoutTraining.isTraining;
    delete initialBotContentWithoutTraining.isTraining;

    const currentEnabled = botContentWithoutTraining.ai_agent_bot_enabled;
    const initialEnabled = initialBotContentWithoutTraining.ai_agent_bot_enabled;

    delete botContentWithoutTraining.ai_agent_bot_enabled;
    delete initialBotContentWithoutTraining.ai_agent_bot_enabled;

    console.log(
      "sdhgkjbgdhgddddfg?",
      botContent?.ingestion_methods,
      !isPreviousIngested(botContent?.ingestion_methods),
      initialEnabled == false,
      currentEnabled == true,
    );

    const enabledToggleChanged =
      !isPreviousIngested(botContent?.ingestion_methods) &&
      initialEnabled == false &&
      currentEnabled == true
        ? false
        : currentEnabled !== initialEnabled;

    console.log("enabledToggleChangedddddddd is it true", enabledToggleChanged);

    const coreChanged = CORE_KEYS.some((key) => {
      if (key === "chat_settings") return false;
      if (key === "isTraining") return false;
      if (key === "ai_agent_bot_enabled") return false;

      const initialValue = initialBotContentWithoutTraining[key];
      const currentValue = botContentWithoutTraining[key];

      if (initialValue === undefined || currentValue === undefined) {
        return false;
      }
      return JSON.stringify(initialValue) !== JSON.stringify(currentValue);
    });

    const chatSettingsChanged =
      JSON.stringify(initialData.chatSettings) !==
      JSON.stringify(localChatSettings);

    const final_result =
      enabledToggleChanged || coreChanged || chatSettingsChanged;

    console.log(
      "final_resultdd",
      final_result,
      enabledToggleChanged,
      coreChanged,
      chatSettingsChanged,
    );
    return final_result;
  };

  const showAlert = (type, message) => {
    setAlert({ show: true, type, message });
  };

  useEffect(() => {
    if (!appData?.tenant_id || !appData?.app_name) return;

    const fetchBotContent = async () => {
      setLoading(true);
      const region = appData.region.toLowerCase();
      try {
        const url = `https://${region}.autobot2.${backend_api_base_url}/get_bot_content?app_name=${appData.app_name}&tenant_id=${appData.tenant_id}`;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "x-api-key": "bGVnYWwxMjNfX1NFVFJBVE9SX190ZXN0ZGRk",
          },
        });

        if (!response.ok) throw new Error("Failed to fetch bot content");

        const data = await response.json();

        console.log("herewiwllgdata", data);
        const kb_id =
          data?.bot_payload?.kb_id || `${data.tenant_id}__${data.app_name}`;

        // const kb_id = `${data.tenant_id}__${data.app_name}`;

        const fetchedBotContent = {
          ...data?.bot_payload,
          ...appData,
          kb_id: kb_id,
        };

        console.log("Fetched bot content for AI Agent:", fetchedBotContent);

        setBotContent(fetchedBotContent);
        setInitialData({
          botContent: { ...fetchedBotContent },
          chatSettings: { ...appData.chat_settings },
        });
      } catch (err) {
        showAlert("error", "❌ " + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBotContent();
  }, [appData]);

  const handleUpdate = async () => {
    console.log("wahterieven called!");
    if (!botContent) {
      showAlert("error", "No AI Agent content to update");
      return;
    }

    const payload1 = {};
    Object.keys(botContent).forEach((key) => {
      if (CORE_KEYS.includes(key)) payload1[key] = botContent[key];
    });

    console.log("AI Agent Payload:", payload1);
    setPendingUpdatePayloads({ payload1 });
    setShowConfirmModal(true);
  };

  const handleCloseAlert = () => {
    setAlert({ ...alert, show: false });
  };

  const handleModalClose = () => {
    setShowConfirmModal(false);
  };

  const isUpdateDisabled = () => {
    const disabled = updating || loading || !botContent;

    if (disabled) {
      console.log("🔘 Update button disabled - basic conditions:", {
        updating,
        loading,
        hasBotContent: !!botContent,
      });
      return true;
    }

    // Don't disable during training - we want to allow updates
    // if (botContent.isTraining === 1) return true;

    const hasCoreConfigChanges = hasChanges();

    // CRITICAL: Check if training is prepared
    const trainingPrepared = isTrainingPreparedRef.current;

    const shouldEnable = hasCoreConfigChanges || trainingPrepared;

    console.log("🔘 Update button state:", {
      hasCoreConfigChanges,
      trainingPrepared,
      shouldEnable,
      isTraining: botContent.isTraining,
      pendingTrainingData: !!pendingTrainingDataRef.current,
      shouldTriggerTraining: shouldTriggerTrainingRef.current,
    });

    // Return true if disabled, false if enabled
    return !shouldEnable;
  };

  if (loading) {
    return (
      <div className={styles.centered}>
        <LoaderComp message="Loading AI Chat Settings" />
      </div>
    );
  }

  if (!botContent) {
    return <div>Error: Unable to load AI Agent content</div>;
  }

  return (
    <div className={styles.botContent_wrap}>
      <h2 className={styles.title}>AI Chat Settings</h2>

      <AIAgentBot
        botContent={botContent}
        setBotContent={setBotContent}
        tenantPlan={tenantPlan}
        onTrainingRequest={handleTrainingRequest}
        fromWhere="update"
      />

      <button
        key={updateButtonKey}
        onClick={handleUpdate}
        disabled={isUpdateDisabled()}
        className={`${styles.updateBtn} ${updating ? styles.disabled : ""}`}
      >
        {updating ? "Updating..." : "Update AI Chat"}
      </button>

      {alert.show && (
        <AlertPopup
          type={alert.type}
          message={alert.message}
          onClose={handleCloseAlert}
        />
      )}

      <Modal
        isOpen={showConfirmModal}
        onClose={handleModalClose}
        hideCloseButton={true}
        title="Confirmation Required"
      >
        <div className={modalContentSty.modalContent}>
          <div className={modalContentSty.modalContentWrap}>
            <div className={modalContentSty.modalContentIc}>⚠️</div>
            <p className={modalContentSty.modalMessage}>
              All the clients would be rebooted! Do you want to continue?
            </p>
          </div>
          <div className={modalContentSty.modalActions}>
            <button
              className={`${modalContentSty.modalButton} ${modalContentSty.cancelBtn}`}
              onClick={() => confirmUpdate(false)}
            >
              Cancel
            </button>
            <button
              className={`${modalContentSty.modalButton} ${modalContentSty.okBtn}`}
              onClick={() => confirmUpdate(true)}
            >
              Ok
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}